<div id="container-fluid" class="grid-container">


  <mat-sidenav-container (backdropClick)="snav.toggle()"  style.marginTop.px="56">
    <mat-sidenav [ngClass]="globals.isHandSet? 'sidenav-container-mobile' : 'sidenav-container'"  #snav mode="over" fixedInViewport="true" fixedTopGap="70" position="end">
      
      <!-- START OF OVERLAY -->

      <div *ngIf="selectedDevice && selectedDevice.name != ''" [ngStyle]="{'padding':globals.isHandSet ? '8px' : '32px' }">
        <div class="row overlay-header-row">
          <div class="col-12">

            <div class="flex-container">
              <div class="overlay-flex-container">
              <div class="header-row-title ">
                <button mat-icon-button (click)="snav.toggle()">
                  <mat-icon>disabled_by_default</mat-icon>
                </button>
              </div>

              <div class="overlay-flex-child" style="font-size: 14px;">
                Hotspot / Device / {{selectedDevice.name}}
              </div>
            </div>
              <span style="float:right;margin-right: 12px;" *ngIf="fwVersion >= 1.14">
                <button mat-stroked-button color="basic" style="height:44px;background-color: white;"
                (click)="reboot()">Reboot</button>
              </span>
       
            </div>
          </div>
        </div>

        <div class="row overlay-hotspot-row">
          <div class="col-12">

            <mat-card class="dash-mat-card">
              <mat-card-title class="title-spacing"
                style="width: 100%; display: flex; align-items: center; align-content: center;">
                <span class="dash-mat-card-line"> </span>
                <span class="dash-mat-card-title">{{selectedDevice.name}}</span>

                <span style=flex:auto></span>
                <span class="overlay-header-status-text">Hotspot Online Status: </span><span>
                  <!-- <div mat-flat-button class="button-ok div-button">synced</div> -->
                  <div *ngIf="selectedDevice.status.online" mat-flat-button class=" button-ok div-button">
                    online</div>
                  <div *ngIf="!selectedDevice.status.online" mat-flat-button class="button-err div-button">
                    offline</div>
                </span>
                <!-- <span class="overlay-header-status-text">Helium Sync Status: </span><span>
                  <div *ngIf="selectedDevice.status.synced" mat-flat-button class="button-ok div-button">synced</div>
                  <div *ngIf="!selectedDevice.status.synced" mat-flat-button class="button-err div-button">offline</div>
                </span> -->


                <hr class="horizontal-divider">

              </mat-card-title>
              <mat-card-content style="width:100%">

                <div class="row">

                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">

                    <table style="width: 100%;">
                      <tbody>
                        <tr>
                          <td class="header-td">SN:</td>
                          <td class="al-r">{{selectedDevice.snr}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">Name:</td>
                          <td class="al-r">{{selectedDevice.name}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">Miner:</td>
                          <td class="al-r">{{selectedDevice.fw}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">Firmware:</td>
                          <td class="al-r">{{selectedDevice.miner}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">Hotspot:</td>
                          <td class="al-r txt-hover info-link-entries" title="{{selectedDevice.address}}" > <span (click)=" clickAddress(selectedDevice.address)"> {{truncate(selectedDevice.address,25,"...")}} </span> <span><mat-icon (click)="copyToClipboard(selectedDevice.address)" style="font-size: 16px;">content_copy</mat-icon></span></td>
                        </tr>
          
                        <tr>
                          <td class="header-td">Owner:</td>
                          <td class="al-r txt-hover info-link-entries" title="{{selectedDevice.owner}}" > <span (click)=" clickOwner(selectedDevice.owner)"> {{truncate(selectedDevice.owner,25,"...")}} </span> <span><mat-icon (click)="copyToClipboard(selectedDevice.owner)" style="font-size: 16px;">content_copy</mat-icon></span></td>

                        </tr>
                        <tr>
                          <td class="header-td">Uptime:</td>
                          <td class="al-r">{{selectedDevice.uptime}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <table style="width: 100%;">
                      <tbody>
                        <tr>
                          <td class="header-td">Public IP Address:</td>
                          <td class="al-r">{{selectedDevice.public_ip}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">CPU ID:</td>
                          <td class="al-r">{{selectedDevice.cpuId}} </td>
                        </tr>
                        <tr>
                          <td class="header-td">CPU Temperature:</td>
                          <td class="al-r progress-td"
                            style="display: flex; align-content: center; align-items: center;">
                            <span style=flex:auto></span> {{selectedDevice.cpu.temp.toFixed(2)}} &deg;C
                            <div *ngIf="!globals.isHandSet" class="chip-progress-mr0" style="width: 200px;">
                              <mat-progress-bar
                                [ngClass]="selectedDevice.cpu.temp >70? 'usage-progress-orange' : 'usage-progress-green ' "
                                mode="determinate" [value]="selectedDevice.cpu.temp">
                              </mat-progress-bar>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="header-td">CPU Usage:</td>
                          <td class="al-r progress-td"><span style=flex:auto></span>
                            {{selectedDevice.cpu.usage.toFixed(2)}} %
                            <div *ngIf="!globals.isHandSet" class="chip-progress-mr0" style="width: 200px;">
                              <mat-progress-bar
                                [ngClass]="selectedDevice.cpu.usage >85? 'usage-progress-orange' : 'usage-progress-green ' "
                                mode="determinate" [value]="selectedDevice.cpu.usage"></mat-progress-bar>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="header-td">Memory Usage:</td>
                          <td  class="al-r progress-td"><span style=flex:auto></span>
                            <span matTooltipPosition="left" matTooltip="{{selectedDevice.memory.tooltip}}">
                              {{(100*(selectedDevice.memory.total-selectedDevice.memory.available)/selectedDevice.memory.total).toFixed(2)}} %</span>
                            <!-- ({{(selectedDevice.memory.used/(1024*1024)).toFixed(0)}} /
                            {{(selectedDevice.memory.total/(1024*1024)).toFixed(0)}}
                            MB) -->
                            <div *ngIf="!globals.isHandSet" class="chip-progress-mr0" style="width: 200px;" matTooltipPosition="left"
                              matTooltip="{{selectedDevice.memory.tooltip}}">
                              <mat-progress-bar
                                [ngClass]="100*(selectedDevice.memory.total-selectedDevice.memory.available)/selectedDevice.memory.total >85? 'usage-progress-orange' : 'usage-progress-green ' "
                                mode="determinate" [value]="100*(selectedDevice.memory.total-selectedDevice.memory.available)/selectedDevice.memory.total">
                              </mat-progress-bar>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="header-td">Storage Usage:</td>
                          <td  class="al-r progress-td"><span style=flex:auto></span>
                            <span matTooltipPosition="left" matTooltip="{{selectedDevice.storage.tooltip}}">
                              {{(selectedDevice.storage.used/selectedDevice.storage.size*100).toFixed(2)}} %</span>
                   
                            <div *ngIf="!globals.isHandSet" class="chip-progress-mr0" style="width: 200px; " matTooltipPosition="left"
                              matTooltip="{{selectedDevice.storage.tooltip}}">
                              <mat-progress-bar
                                [ngClass]="selectedDevice.storage.used/selectedDevice.storage.size*100 >85? 'usage-progress-orange' : 'usage-progress-green ' "
                                mode="determinate"
                                [value]="selectedDevice.storage.used/selectedDevice.storage.size*100">
                              </mat-progress-bar>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>


              </mat-card-content>
            </mat-card>

          </div>
        </div>

        <div class="row; row-size; overlay-rewards-row">
          <div class="col-12">
            <!-- Hotspot rewards -->
            <div class="col-12 col-pad">

              <mat-card class="dash-mat-card">
                <mat-card-title class="title-spacing">
                  <span class="dash-mat-card-line"> </span>
                  <span class="dash-mat-card-title">Rewards Overview (HNT)</span>
                </mat-card-title>
                <mat-card-content style="width:100%">

                  <div class="row card1-content">
                    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-no-margin">
                      <div class="chip">
                        <div class="chip-title">Last 24h</div>
                        <div class="chip-content">
                          {{selectedDevice.earnings && selectedDevice.earnings.day ? selectedDevice.earnings.day.toFixed(8) : 0}}
                        </div>

                      </div>
                    </div>
                    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-no-margin">
                      <div class="chip">
                        <div class="chip-title">Last 7d</div>
                        <div class="chip-content">
                          {{selectedDevice.earnings && selectedDevice.earnings.week ? selectedDevice.earnings.week.toFixed(8) : 0}}
                        </div>

                      </div>
                    </div>
                    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-no-margin">
                      <div class="chip">
                        <div class="chip-title">Last 30d</div>
                        <div class="chip-content">
                          {{selectedDevice.earnings && selectedDevice.earnings.month ? selectedDevice.earnings.month.toFixed(8) : 0}}
                        </div>

                      </div>
                    </div>
                    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-no-margin">
                      <div class="chip">
                        <div class="chip-title">Total 1yr</div>
                        <div class="chip-content">
                          {{selectedDevice.earnings && selectedDevice.earnings.total ? selectedDevice.earnings.total.toFixed(8) : 0}}
                        </div>

                      </div>
                    </div>

                  </div>


                </mat-card-content>
              </mat-card>
            </div>

          </div>
        </div>

        <div class="row overlay-additional-row" style="min-height: 460px;">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
            <!-- Additional Details -->
            <mat-card class="dash-mat-card" style="min-height: 460px;">
              <mat-card-title class="title-spacing" >
                <span class="dash-mat-card-line"> </span>
                <span *ngIf="additionalDetailsSelection=='hotspot'" class="dash-mat-card-title">Additional Details</span>
                <span *ngIf="additionalDetailsSelection=='validator'" class="dash-mat-card-title">Validator Info</span>
                <span style="float:right">
                  <!-- <mat-button-toggle-group #group="matButtonToggleGroup" name="favoriteColor" [value]="additionalDetailsSelection" (change)="onAdditionalDetailsSelection(group.value)">
                    <mat-button-toggle value="hotspot" >Hotspot</mat-button-toggle>
                    <mat-button-toggle value="validator">Validator</mat-button-toggle>
                </mat-button-toggle-group> -->
                </span>
                <hr class="horizontal-divider">
              </mat-card-title>
              <mat-card-content style="width:100%">

                <!-- HOTSPOT DETAILS -->
                <div *ngIf="additionalDetailsSelection=='hotspot'" class="row">
                  <div class="col-12">

                    <table style="width: 100%; vertical-align: top;">
                      <tbody style=" vertical-align: top;">
                        <!-- <tr>
                          <td class="header-td">P2P Status:</td>
                          <td class="al-r flex-style">
                            <span style=flex:auto></span>
                            <span>
                              <div mat-flat-button
                                [ngClass]="selectedDevice.p2pdata && selectedDevice.p2pdata != -1 && selectedDevice.p2pdata.connected == 'yes'&& selectedDevice.p2pdata.dialable == 'yes' ? 'button-ok div-button progress-button ' : 'button-err div-button progress-button ' ">
                                {{selectedDevice.p2pdata && selectedDevice.p2pdata != -1 && selectedDevice.p2pdata.connected == 'yes'&& selectedDevice.p2pdata.dialable == 'yes'? 'Healthy':'Unhealthy'}}
                              </div>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td class="header-td">P2P Outbound:</td>
                          <td class="al-r flex-style"><span style=flex:auto></span>
                            <span>
                              <div mat-flat-button
                                [ngClass]="selectedDevice.p2pdata && selectedDevice.p2pdata != -1 && selectedDevice.p2pdata.connected == 'yes'? 'button-ok div-button progress-button ' : 'button-err div-button progress-button ' ">
                                {{selectedDevice.p2pdata && selectedDevice.p2pdata != -1 && selectedDevice.p2pdata.connected == 'yes'? 'Healthy':'Error'}}
                              </div>
                            </span>

                          </td>
                        </tr>
                        <tr>
                          <td class="header-td">P2P Inbound:</td>
                          <td class="al-r flex-style"><span style=flex:auto></span>
                            <span>
                              <div mat-flat-button
                                [ngClass]="selectedDevice.p2pdata && selectedDevice.p2pdata != -1 && selectedDevice.p2pdata.dialable == 'yes'? 'button-ok div-button progress-button ' : 'button-err div-button progress-button ' ">
                                {{selectedDevice.p2pdata && selectedDevice.p2pdata != -1 && selectedDevice.p2pdata.dialable == 'yes'? 'Healthy':'Error'}}
                              </div>
                            </span>

                          </td>

                        </tr> -->
                        <tr>
                          <td class="header-td">Antenna (gain):</td>
                          <td class="al-r">{{selectedDevice.antenna.gain/10}} dBi</td>
                        </tr>
                        <tr>
                          <td class="header-td">Antenna (elevation):</td>
                          <td class="al-r">{{selectedDevice.antenna.elevation}} m</td>
                        </tr>
                        <tr>
                          <td class="header-td">Wifi Name:</td>
                          <td class="al-r">{{selectedDevice.wifiSSID}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">Wifi IP Address:</td>
                          <td class="al-r">{{selectedDevice.wifiIp}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">LAN IP Address:</td>
                          <td class="al-r">{{selectedDevice.lanIp}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">Coordinates:</td>
                          <td class="al-r">
                            ({{selectedDevice.position.lat.toFixed(6)}}, {{selectedDevice.position.lng.toFixed(6)}})
                          </td>
                        </tr>
                        <tr>
                          <td class="header-td"> Address:</td>
                          <td class="al-r">

                            {{selectedDevice.position.geocode.long_country}},
                            {{selectedDevice.position.geocode.long_state}},<br>
                            {{selectedDevice.position.geocode.long_city}},
                            {{selectedDevice.position.geocode.long_street}}
                          </td>
                        </tr>
                        <br>
                        <tr>
                          <td class="header-td">Collection Time:</td>
                          <td class="al-r">{{selectedDevice.collectTime1}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">Added to Helium Network:</td>
                          <td class="al-r">{{selectedDevice.addedTime}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">Production Time:</td>
                          <td class="al-r">{{selectedDevice.prod_time}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- VALIDATOR INFO -->
                <div *ngIf="additionalDetailsSelection=='validator'" class="row">
                  <div class="col-12">

                    <table style="width: 100%; vertical-align: top;">
                      <tbody style=" vertical-align: top;">
                       
                        <!-- Status -->
                        <tr>
                          <td class="header-td">Status:</td>
                          <td class="al-r flex-style"><span style=flex:auto></span>
                            <span>
                              <div mat-flat-button
                                [ngClass]="selectedDevice.validator && selectedDevice.validator.status? 'button-ok div-button progress-button ' : 'button-err div-button progress-button ' ">
                                {{selectedDevice.validator && selectedDevice.validator.status?  'Healthy' : selectedDevice.validator && selectedDevice.validator.address ?'Unhealthy': 'Not Found'}}
                              </div>
                            </span>
                          </td>
                        </tr>

                        <!-- Name -->
                        <tr>
                          <td class="header-td">Name:</td>
                          <td class="al-r">{{selectedDevice.validator.name ? selectedDevice.validator.name : "Unknown"}}</td>
                        </tr>
                        <!-- IP -->
                        <tr>
                          <td class="header-td">IP Address:</td>
                          <td class="al-r">{{selectedDevice.validator.ip ? selectedDevice.validator.ip : "Unknown"}}</td>
                        </tr>
                        <!-- Last Heartbeat -->
                        <tr>
                          <td class="header-td">Last Heartbeat:</td>
                          <td class="al-r">{{selectedDevice.validator.lastHeartbeat ? selectedDevice.validator.lastHeartbeat : "Unknown"}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">Version:</td>
                          <td class="al-r">{{selectedDevice.validator.version ? selectedDevice.validator.version: "Unknown"}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">Listen IP:</td>
                          <td class="al-r">{{selectedDevice.validator.listenIP ? selectedDevice.validator.listenIP : "Unknown"}}</td>
                        </tr>
                        <tr>
                          <td class="header-td">Address:</td>
                  
                          <td class="al-r txt-hover info-link-entries" title="{{selectedDevice.validator.address ? selectedDevice.validator.address : ''}}" > <span  (click)="clickValidatorAddress(selectedDevice.validator.address ? selectedDevice.validator.address : '' )"> {{selectedDevice.validator.address ? truncate(selectedDevice.validator.address,25,"...") : "Unknown"}} </span> <span *ngIf="selectedDevice.validator.address"><mat-icon (click)="copyToClipboard(selectedDevice.validator.address)" style="font-size: 16px;">content_copy</mat-icon></span></td>

                        </tr>

                     
                      </tbody>
                    </table>
                  </div>
                </div>


              </mat-card-content>
            </mat-card>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
            <mat-card class="dash-mat-card" style="min-height: 460px; max-height: 460px;">
              <mat-card-title class="title-spacing">
                <span class="dash-mat-card-line"> </span>
                <span *ngIf="blockchainActivitySelection == 'blockchain'" class="dash-mat-card-title">Blockchain</span>
                <span *ngIf="blockchainActivitySelection == 'activity'" class="dash-mat-card-title">Activity</span>
                <span style="float:right">
                  <!-- <mat-button-toggle-group #group1="matButtonToggleGroup" [value]="blockchainActivitySelection" (change)="onBlockChainActivitySelector(group1.value)">
                    <mat-button-toggle value="blockchain" >Blockchain</mat-button-toggle>
                    <mat-button-toggle value="activity">Activity</mat-button-toggle>
                </mat-button-toggle-group> -->
                </span>
                <hr class="horizontal-divider">
              </mat-card-title>
              <mat-card-content style="width:100%; overflow-y: scroll; overflow-x: hidden; padding-left:5px; padding-right: 5px;">

                
                <div *ngIf="blockchainActivitySelection == 'blockchain'" class="row">
                  <div class="col-12">

                    <table style="width: 100%;">
                      <tbody>
                        <tr>
                          <td class="header-td">Blockchain Synced:</td>
                          <td class="al-r flex-style">
                            <span style=flex:auto></span>

                            <span>
                              <div *ngIf="selectedDevice.status.syncedPercentage >= 100" mat-flat-button
                                class="button-ok div-button-1">Fully Synced
                                {{selectedDevice.status.syncedPercentage.toFixed(2)}}%
                              </div>
                              <div
                                *ngIf="selectedDevice.status.syncedPercentage < 100 && selectedDevice.status.syncedPercentage >= 98"
                                mat-flat-button class="button-ok div-button-1">Synced
                                <!-- {{selectedDevice.status.syncedPercentage.toFixed(3)}}%</div> -->
                                {{selectedDeviceRaw && selectedDeviceRaw[0] ? selectedDeviceRaw[0].percentage.toFixed(3):'0.000'}}%</div>
                              <div *ngIf="selectedDevice.status.syncedPercentage < 98" mat-flat-button
                                class="button-err div-button-1">Not Synced
                                {{selectedDeviceRaw && selectedDeviceRaw[0] ? selectedDeviceRaw[0].percentage.toFixed(3):'0.000'}}%
                              </div>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td class="header-td">Blockchain Height:</td>
                          <td class="al-r flex-style">

                          </td>
                        </tr>
                        <!-- ngFor from here: ignore first raw entry as it is in above entry -->
                        <tr *ngFor="let entry of selectedDeviceRaw; let i =index">
                          <td *ngIf="i != selectedDeviceRaw.length-1">{{entry.date}}</td>
                          <td *ngIf=" i != selectedDeviceRaw.length-1" class="al-r flex-style">

                            <span style=flex:auto></span>
                            <span>(+{{entry.diff}}) <span *ngIf="!globals.isHandSet">{{entry.miner}} / {{entry.helium}}</span></span>
                            <span>
                              <div mat-flat-button
                                [ngClass]="entry.percentage >= 98 ? 'button-ok div-button-1 progress-button' : 'button-err div-button-1 progress-button' ">
                                {{entry.percentage.toFixed(2)}}%</div>
                            </span>
                          </td>
                        </tr>





                      </tbody>
                    </table>
                  </div>

                </div>

                <div *ngIf="blockchainActivitySelection == 'activity'" class="row">
                  <div class="col-12">
                    <!-- <div ></div> -->

                    <mat-spinner *ngIf="selectedDevice.activities && selectedDevice.activities.length==0 && activitySpinner" style="    margin: auto; margin-top: 10%;"></mat-spinner>

                    <!-- <mat-list > -->
                    <div *ngFor="let entry of selectedDevice.activities; let i =index" style=" border-bottom: lightgray solid;border-width: 1px;margin-bottom: 5px;">
                     
                        <!-- REWARDS -->
                        <div *ngIf="entry.type=='rewards_v2'" style="display: flex; margin-right: 10px;"  ><span style = "width: 40px;"> <mat-icon>star_rate</mat-icon></span>  <span i>Receive Mining Rewards</span><span style="flex:auto;"></span>   <span >{{globals.timeSince(entry.time)}}</span></div>
                    
                        <!-- WITNESS -->
                        <div *ngIf="entry.type=='poc_receipts_v2' && !entry.beacon" style="display: flex; margin-right: 10px;"><span style = "width: 40px;"> <mat-icon>visibility</mat-icon></span>Witnessed Beacon <span style="flex:auto;"></span><span>{{globals.timeSince(entry.time)}}</span></div>


                        <!-- BEACON -->
                        <div *ngIf="entry.type=='poc_receipts_v2' && entry.beacon" style="display: flex; margin-right: 10px;"><span style = "width: 40px;"> <mat-icon>sensors</mat-icon></span>Broadcast Beacon<span style="flex:auto;"></span><span>{{globals.timeSince(entry.time)}}</span></div>

                        <!-- ASSERT -->
                        <div *ngIf="entry.type=='assert_location_v2'" style="display: flex;"><span style = "width: 40px; margin-right: 10px;"> <mat-icon>share_location</mat-icon></span>Assert Location<span style="flex:auto;"></span><span>{{globals.timeSince(entry.time)}}</span></div>

                        <!-- TRANSFER DATA -->
                        <div *ngIf="entry.type=='state_channel_close_v1'" style="display: flex; margin-right: 10px;"><span style = "width: 40px; "> <mat-icon>published_with_changes</mat-icon></span>Transferred Packets<span style="flex:auto;"></span><span>{{globals.timeSince(entry.time)}}</span></div>

                        <!-- ADD GATEWAY-->
                        <div *ngIf="entry.type=='add_gateway_v1'" style="display: flex; margin-right: 10px;"><span style = "width: 40px; "> <mat-icon>add_circle_outline</mat-icon></span>Added to Blockchain<span style="flex:auto;"></span><span>{{globals.timeSince(entry.time)}}</span></div>

                    </div>
                      
                    <!-- </mat-list> -->
                   
                  </div>

                </div>


              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
      <!-- END OF OVERLAY -->

    </mat-sidenav>

    <mat-sidenav-content>
      <div class="row row-size">
        <div class="col-12 col-pad">
          <div class="header-row">
            <div class="flex-container">

              <div class="header-row-title ">Hotspot Devices</div>
              <div class="flex-child">
                <span id="device-table-form" style="font-size: 12px;">
                  <span>
                    <mat-form-field appearance="outline" color="primary" [ngStyle]="{'width':globals.isHandSet ? '30vw':'20vw' }">
                      <mat-label color="accent">
                        Search
                      </mat-label>
                      <input matInput (keyup)="applyThingsFilter($event)" #searchInput>
                      <span matSuffix>
                        <mat-icon>search</mat-icon>
                      </span>
                    </mat-form-field>
                  </span>
                  <!-- <span
                    style="height:44px; margin: 0.25em 0; margin-left:24px;     padding-bottom: 1.34375em; line-height: 1.125;">

                    <button mat-mini-fab color="basic" class="button24 mat-elevation-z0" style="font-size: 24px;"
                      aria-label="Example icon button with a delete icon">
                      <mat-icon class="icon24" (click)="openAddDeviceDialog()">add</mat-icon>
                    </button>
                  </span> -->
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-size">
        <div class="col-12 col-pad">


          <div class="table-container" style="width: 100%; height:100%;">
            <div
              style="height:44px; ; margin-right:24px; margin-bottom: 18px;    padding-bottom: 1.34375em; line-height: 1.125;">
              <button mat-stroked-button color="basic" style="height:44px;background-color: white;"
                (click)="refreshPage()">Refresh</button>
               
                <span style="height:44px; margin: 0.25em 0; margin-left:24px;     padding-bottom: 1.34375em; line-height: 1.125; float:right">
                  <button mat-mini-fab color="basic" class="button24 mat-elevation-z0" style="font-size: 24px;">
                    <mat-icon class="icon24" (click)="openAddDeviceDialog()">add</mat-icon>
                  </button>
                </span>

            </div>


            <table class="dev-table" mat-table [dataSource]="protonsDataSource" matSort style="width: 100%; "matSortActive="name" matSortDirection="asc" >
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header start="asc" disabled = 'true'>No.</th>
                <td mat-cell *matCellDef="let element let i =index">{{i+1+(selectedPage*10)}}</td>
                <td mat-footer-cell *matFooterCellDef> </td>

              </ng-container>

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header direction="desc">Hotspot Name</th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{element.name}}</td>
                <td mat-footer-cell *matFooterCellDef> </td>
              </ng-container>

              <ng-container matColumnDef="address" >
                <th mat-header-cell [hidden]="globals.isHandSet" *matHeaderCellDef mat-sort-header>Hotspot Address</th>
                <td mat-cell [hidden]="globals.isHandSet" class='table-link-entries txt-hover' (click)="snav.toggle(); clickAddress(element.address)"
                  *matCellDef="let element">
                  {{truncate(element.address,30,'...')}}</td>
                <td mat-footer-cell *matFooterCellDef> </td>
              </ng-container>

              <ng-container matColumnDef="owner">
                <th mat-header-cell [hidden]="globals.isHandSet || !globals.isSmall" *matHeaderCellDef mat-sort-header >Hotspot Owner</th>
                <td  [hidden]="globals.isHandSet || !globals.isSmall"mat-cell class='table-link-entries txt-hover' (click)="snav.toggle(); clickOwner(element.owner)"
                  *matCellDef="let element">
                  {{truncate(element.owner,30,'...')}}</td>
                <td mat-footer-cell *matFooterCellDef> </td>
              </ng-container>

              <ng-container matColumnDef="earnings">
                <th [hidden]="globals.isHandSet"mat-header-cell *matHeaderCellDef mat-sort-header disabled>24H Rewards (HNT)</th>
                <td [hidden]="globals.isHandSet"mat-cell *matCellDef="let element; let i = index">
                  <button *ngIf="element.earnings.day > 0" mat-flat-button
                    class="button-ok"> + {{element.earnings.day.toFixed(5)}} </button>
                    <button *ngIf="element.earnings.day <= 0" mat-flat-button
                      class="button-grey"> + {{element.earnings.day.toFixed(5)}} </button>
                 </td>
                <td [hidden]="globals.isHandSet"mat-footer-cell *matFooterCellDef> </td>
              </ng-container>

              <ng-container matColumnDef="minerVersion">
                <th [hidden]="globals.isHandSet" mat-header-cell *matHeaderCellDef mat-sort-header disabled = 'true'>Firmware</th>
                <td [hidden]="globals.isHandSet" mat-cell class='table-entries' *matCellDef="let element">{{element.miner==1?'N/A':element.miner}} </td>
                <td [hidden]="globals.isHandSet" mat-footer-cell *matFooterCellDef> </td>
              </ng-container>

              <ng-container matColumnDef="fwVersion">
                <th [hidden]="globals.isHandSet" mat-header-cell *matHeaderCellDef mat-sort-header disabled = 'true'>Miner </th>
                <td [hidden]="globals.isHandSet" mat-cell class='table-entries' *matCellDef="let element">{{element.fw==1?'N/A':element.fw}} </td>
                <td [hidden]="globals.isHandSet" mat-footer-cell *matFooterCellDef> </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th style="text-align:center !important"  mat-header-cell *matHeaderCellDef mat-sort-header disabled = 'true'></th>
                <td mat-cell class='table-entries' *matCellDef="let element">

                  <button *ngIf="element.status.online" mat-flat-button matTooltipPosition="left" matTooltip="{{element.collectTime}}"
                    class="button-ok-1">{{element.status.online ? 'ONLINE ': 'OFFLINE'}}</button>
                  <button *ngIf="!element.status.online" mat-flat-button matTooltipPosition="left" matTooltip="{{element.collectTime}}"
                    class="button-err-1">{{element.status.online? 'ONLINE ': 'OFFLINE'}}</button>

                    <button style="padding: 0px;" *ngIf="element.hasWarning" mat-button matTooltipPosition="left" matTooltip="{{element.warningMessage}}"   matTooltipClass="my-tooltip"

                    class="button-info-1"><span class="material-icons-outlined" style = "padding: 0px;">
                      report
                      </span></button>
                    

                </td>
                <td mat-footer-cell *matFooterCellDef> </td>
              </ng-container>

              <ng-container matColumnDef="star">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" (click)="snav.toggle(); decommission(element)">
                  <mat-icon>delete_forever</mat-icon>
                </td>
                <td mat-footer-cell *matFooterCellDef> </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="protonDispCols"></tr>
              <tr mat-row class='table-entries' *matRowDef="let row; columns: protonDispCols; let i = index"
                (click)="selectDevice(i,row); snav.toggle()"></tr>
              <tr mat-footer-row *matFooterRowDef="protonDispCols" class="example-first-footer-row"></tr>

            </table>


            <mat-paginator #matPagProtons [pageSizeOptions]="[10]" showFirstLastButtons (page)="onProtonPageChange($event)"
              aria-label="Select page of users">
            </mat-paginator>

          </div>

        </div>
      </div>


      <!--  -->
    </mat-sidenav-content>
  </mat-sidenav-container>




</div>
